
//查询组件集合
export const dirComponentByDetails = (data) => {
	return {
		url: "/rest/component/v1/dirComponentByDetails",
		method: "post",
		data: data,
		openMock: false,
		mock: null,
	}
}

//批量组件查询
export const dirDefaultComponent = (data) => {
	return {
		url: "/rest/component/v1/dirDefaultComponent",
		method: "post",
		data: data,
		openMock: false,
		mock: null,
	}
}